(function() {
  'use strict';

  function syncSelectedImagePair(selectedItem, primaryImageEl, hoverImageEl) {
    if (!selectedItem || !primaryImageEl) return;
    const imgs = selectedItem.querySelectorAll('.product-options-card__image img');
    const primaryImage = imgs[0];
    const secondaryImage = imgs[1] || selectedItem.querySelector('.product-options-card__image img.motion-reduce');
    const imageSrc = primaryImage ? (primaryImage.src || primaryImage.getAttribute('src')) : '';
    const imageAlt = primaryImage ? primaryImage.alt : '';
    const secondarySrc = secondaryImage ? (secondaryImage.src || secondaryImage.getAttribute('src')) : '';
    const secondaryAlt = secondaryImage ? secondaryImage.alt : '';
    const containerEl = primaryImageEl.closest('.product-options-card__selected-image');

    if (imageSrc) {
      primaryImageEl.src = imageSrc;
      primaryImageEl.alt = imageAlt || selectedItem.getAttribute('data-title') || '';
    }

    if (hoverImageEl && containerEl) {
      containerEl.classList.remove('product-options-card__selected-image--flipped');
      if (secondarySrc) {
        hoverImageEl.src = secondarySrc;
        hoverImageEl.alt = secondaryAlt || primaryImageEl.alt;
        hoverImageEl.removeAttribute('hidden');
        containerEl.classList.add('product-options-card__selected-image--has-secondary');
      } else {
        hoverImageEl.removeAttribute('src');
        hoverImageEl.alt = '';
        hoverImageEl.setAttribute('hidden', '');
        containerEl.classList.remove('product-options-card__selected-image--has-secondary');
      }
    }
  }

  // Simple function to update selected item display
  function updateSelectedItemDisplay() {
    // Update header/design display (works for both custom and roman configurators)
    const selectedHeader = document.querySelector('.product-options-card__grid--gallery-view .product-options-card__item.selected');
    const selectedDesign = document.querySelector('.product-options-card__grid--design .product-options-card__item.selected');
    const selectedItem = selectedHeader || selectedDesign;
    
    if (selectedItem) {
      const productId = selectedItem.getAttribute('data-product-id');
      const title = selectedItem.getAttribute('data-title') || '';
      const descEl = document.getElementById(`product-description-${productId}`);
      const description = descEl ? descEl.innerHTML : 'Please select an option to see details here.';

      // IMPORTANT: There can be multiple selected panels on the page (duplicate IDs in different accordions).
      // Always update the panel that belongs to the same grid as the selected item.
      const grid = selectedItem.closest('.product-options-card__grid');
      const selectedPanel = grid ? grid.querySelector('.product-options-card__selected') : null;

      const itemImageEl =
        (selectedPanel && selectedPanel.querySelector('.product-options-card__selected-image--primary')) ||
        document.getElementById('selected-item-image');
      const itemHoverImageEl =
        (selectedPanel && selectedPanel.querySelector('.product-options-card__selected-image--hover')) ||
        document.getElementById('selected-item-image-hover');
      syncSelectedImagePair(selectedItem, itemImageEl, itemHoverImageEl);

      const itemTitleEl =
        (selectedPanel && selectedPanel.querySelector('.product-options-card__selected-title')) ||
        document.getElementById('selected-item-title');
      if (itemTitleEl) {
        itemTitleEl.textContent = title || 'Select an option';
      }

      const itemDescEl =
        (selectedPanel && selectedPanel.querySelector('.product-options-card__selected-description')) ||
        document.getElementById('selected-item-description');
      if (itemDescEl) {
        itemDescEl.innerHTML = description;
      }
    }

    // Update lining display
    const selectedLining = document.querySelector('.product-options-card__grid--lines .product-options-card__item.selected');
    if (selectedLining) {
      const productId = selectedLining.getAttribute('data-product-id');
      const title = selectedLining.getAttribute('data-title') || '';
      const descEl = document.getElementById(`product-description-${productId}`);
      const description = descEl ? descEl.innerHTML : 'Please select an option to see details here.';

      const liningImageEl = document.getElementById('selected-lining-image');
      const liningHoverImageEl = document.getElementById('selected-lining-image-hover');
      syncSelectedImagePair(selectedLining, liningImageEl, liningHoverImageEl);

      const liningTitleEl = document.getElementById('selected-lining-title');
      if (liningTitleEl) {
        liningTitleEl.textContent = title || 'Select an option';
      }

      const liningDescEl = document.getElementById('selected-lining-description');
      if (liningDescEl) {
        liningDescEl.innerHTML = description;
      }
    }
  }

  function isFlipToggleViewport() {
    return window.matchMedia('(max-width: 1033px)').matches;
  }

  function initSelectedItemsDisplay() {
    if (window.__hpdSelectedItemsDisplayInitialized) return;
    window.__hpdSelectedItemsDisplayInitialized = true;

    function scheduleUpdate() {
      // Small delay helps when other scripts toggle `.selected` and inject descriptions in same tick.
      setTimeout(updateSelectedItemDisplay, 0);
    }

    // Configurator emits this after programmatic default selections + user selections.
    document.addEventListener('hpd:configurator:selection-updated', scheduleUpdate);

    document.addEventListener('click', function(e) {
      const flipBtn = e.target.closest('.product-options-card__selected-image .icon-flip');
      if (flipBtn && isFlipToggleViewport()) {
        const container = flipBtn.closest('.product-options-card__selected-image');
        if (container && container.classList.contains('product-options-card__selected-image--has-secondary')) {
          e.preventDefault();
          const flipped = container.classList.toggle('product-options-card__selected-image--flipped');
          flipBtn.setAttribute('aria-pressed', flipped ? 'true' : 'false');
        }
        return;
      }

      const item = e.target.closest('.product-options-card__item');
      if (item) {
        setTimeout(updateSelectedItemDisplay, 10);
      }
    });

    // Initial update after DOM is ready + a safety update on full load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        scheduleUpdate();
      }, { once: true });
    } else {
      scheduleUpdate();
    }

    window.addEventListener('load', function() {
      scheduleUpdate();
    }, { once: true });
  }

  const __prevInitProductPage = window.initProductPage;
  window.initProductPage = function() {
    if (typeof __prevInitProductPage === 'function') __prevInitProductPage();
    initSelectedItemsDisplay();
  };

  // Ensure we initialize even if initProductPage isn't called
  initSelectedItemsDisplay();

})();
